import type { FC } from 'react';
import { placeholderLikeClasses } from 'src/components/form/styles';

type Props = {
  label?: string | JSX.Element;
};

export const EmptyValue: FC<Props> = ({ label = '--' }) => (
  <span className={placeholderLikeClasses}>{label}</span>
);
